import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { MessagesSquare } from "lucide-react";

import { PlaceholderPage } from "@/components/cinch/PlaceholderPage";
import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

function AiConversationsPage() {
  return (
    <PlaceholderPage
      title="AI Conversations"
      description="Observe and audit AI agent conversations happening across the company."
      icon={MessagesSquare}
      plannedCapabilities={[
        "Live and historical conversation feed across all agents",
        "Filter by agent, user, channel, or outcome",
        "Flagged-response review queue",
        "Token + cost rollups per agent and per user",
      ]}
    />
  );
}

export const aiConversationsModule: FeatureModule = {
  key: "ai_conversations",
  nav: {
    label: "AI Conversations",
    icon: MessagesSquare,
    to: "/ai-conversations",
    requires: "ai_conversations.read",
    order: 30,
    group: "Monitors",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/ai-conversations",
      component: guarded("ai_conversations.read", AiConversationsPage),
    }),
  ] as unknown as AnyRoute[],
};
